var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("Admin © "+_vm._s(_vm._f("moment")(new Date(),'YYYY')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }